
import isString from 'lodash/isString';

import { Log } from '../../core';
const log = Log.getLogger('MultiSceneForApp.map.utils.readProject');

function readProject(token, project, mapActions) {
    if (isString(project)) {
        readProjectFromString(token, project, mapActions);
    } else {
        readProjectFromObject(project, mapActions);
    }
}

function readProjectFromObject(project, mapActions) {
    log.debug(`read project from object`);
    mapActions.setProject(project);
}

function readProjectFromString(token, projectId, mapActions) {
    log.debug(`read project from ID '${projectId}'`);
    mapActions.getProject(token, projectId);
}

export default readProject;
